__turbopack_context__.v({
  "caption": "scorecard-module-scss-module__T_2POq__caption",
  "cardContainer": "scorecard-module-scss-module__T_2POq__cardContainer",
  "cardContainerNoSwadow": "scorecard-module-scss-module__T_2POq__cardContainerNoSwadow",
  "cardContent": "scorecard-module-scss-module__T_2POq__cardContent",
  "cardContentZerocase": "scorecard-module-scss-module__T_2POq__cardContentZerocase",
  "cardHeader": "scorecard-module-scss-module__T_2POq__cardHeader",
  "cardHeaderActions": "scorecard-module-scss-module__T_2POq__cardHeaderActions",
  "cardHeaderTitle": "scorecard-module-scss-module__T_2POq__cardHeaderTitle",
  "cardHeaderTitleBrackets": "scorecard-module-scss-module__T_2POq__cardHeaderTitleBrackets",
  "cardInner": "scorecard-module-scss-module__T_2POq__cardInner",
  "cardInnerHorizontal": "scorecard-module-scss-module__T_2POq__cardInnerHorizontal",
  "cardInnerVertical": "scorecard-module-scss-module__T_2POq__cardInnerVertical",
  "label": "scorecard-module-scss-module__T_2POq__label",
  "standingTableContainer": "scorecard-module-scss-module__T_2POq__standingTableContainer",
});
